import { createContext, type ReactNode, useContext } from 'react';
import { defaultLocale, type Locale, type Messages, messages } from '../messages';

interface LocaleContextValue {
  locale: Locale;
  t: Messages;
}

const LocaleContext = createContext<LocaleContextValue>({
  locale: defaultLocale,
  t: messages[defaultLocale],
});

interface Props {
  locale: Locale;
  children: ReactNode;
}

export const LocaleProvider = ({ locale, children }: Props) => (
  <LocaleContext.Provider value={{ locale, t: messages[locale] }}>
    {children}
  </LocaleContext.Provider>
);

export const useLocale = (): Locale => useContext(LocaleContext).locale;

export const useMessages = (): Messages => useContext(LocaleContext).t;
